// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BaseModal_overlay__Ro9m4","modal":"BaseModal_modal__1lwgg"};